<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div class="step step-1">
    <div class="file-upload" v-if="!isVIEWER">
      <div class="giga-file_upload">
        <div class="giga-file_upload_row">
          <div
            class="drop_files_here giga-drop-files_zone"
            :class="{
              'drop-active': $refs.upload && $refs.upload.dropActive
            }"
          >
            <div class="giga-file_upload_text">
              <i>
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_201_6190)">
                    <path
                      d="M21.2929 21.293L15.9697 15.9697L10.6465 21.293"
                      stroke="#132D48"
                      stroke-width="2.66162"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15.9697 15.9697V27.947"
                      stroke="#132D48"
                      stroke-width="1.87879"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M27.1352 24.4735C28.4332 23.7658 29.4586 22.6461 30.0495 21.291C30.6404 19.9359 30.7633 18.4226 30.3986 16.9899C30.034 15.5573 29.2026 14.2868 28.0357 13.3791C26.8688 12.4714 25.4329 11.9782 23.9546 11.9772H22.2777C21.8749 10.4191 21.1241 8.97266 20.0818 7.74654C19.0395 6.52041 17.7328 5.54652 16.26 4.89809C14.7871 4.24967 13.1864 3.94357 11.5782 4.00283C9.97001 4.06208 8.39617 4.48513 6.97502 5.24019C5.55386 5.99524 4.32236 7.06265 3.37311 8.36215C2.42386 9.66166 1.78156 11.1595 1.49449 12.7429C1.20742 14.3264 1.28306 15.9543 1.71571 17.5044C2.14837 19.0544 2.92679 20.4862 3.99244 21.6921"
                      stroke="#132D48"
                      stroke-width="1.87879"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M21.2929 21.293L15.9697 15.9697L10.6465 21.293"
                      stroke="#132D48"
                      stroke-width="1.87879"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_201_6190">
                      <rect width="31.9394" height="31.9394" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </i>
              <span>Glisser-Déposer vos documents</span>
            </div>
            <div class="giga-file_upload_button giga-button">
              <label class="giga-blue_button no-icon" :for="fileUploadId">
                <span>{{ $t("add_document") }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <vue-file-upload
        :input-id="fileUploadId"
        :disabled="isVIEWER || !formIsValid"
        :multiple="false"
        :thread="1"
        :drop="drop"
        :add-index="addIndex"
        v-model="files"
        :extensions="extensions"
        @input-file="uploadImportInMassDoc"
        ref="upload"
      >
      </vue-file-upload>

      <div class="giga-files_upload" v-if="files.length">
        <div class="giga-files_upload_section">
          <div class="giga-files_upload_header">
            <div class="giga-files_header_col_action"></div>
            <div class="giga-files_header_col_name">
              <h3 class="giga-files_upload_title">
                Nom du document
              </h3>
            </div>
          </div>

          <list-estimation-in-mass-doc
            :estimationsPreview="estimationsPreview"
            :rejects="rejects"
            :replace="replace"
            :documents="this.getDrafts"
            :files="files"
            :action-type="'add'"
            :isPreviewInProgress="isPreviewInProgress"
            @draft-deleted="initFiles"
          >
          </list-estimation-in-mass-doc>
        </div>
      </div>

      <div class="import-previews-div" v-if="this.importPreviews">
        <div class="alert">
          <span class="material-symbols-outlined">info</span>
          <span
            >Voici un aperçu des opérations de votre fichier. Cliquez sur
            Suivant pour débuter l’import des opérations</span
          >
        </div>
        <div
          v-if="this.importPreviews.rejections"
          class="section reject-section"
        >
          <status-indicator
            statusText="Opérations défaillantes"
            statusColor="red"
            sizeType="large"
          />
          <div class="operations-table">
            <span>
              Les opérations suivantes sont défaillantes et ne seront donc pas
              importées
            </span>
            <section class="table-section">
              <table class="giga-table">
                <thead>
                  <tr>
                    <th class="line-col" scope="col">
                      Numéro de la ligne
                    </th>

                    <th class="motif-col" scope="col">
                      Motifs de rejet
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(reject, index) in rejects">
                    <tr :key="index">
                      <td data-label="Numéro de la ligne">
                        <p>{{ reject.line }}</p>
                      </td>
                      <td data-label="Motifs de rejet">
                        <ul>
                          <li
                            class="disc"
                            v-for="(reason, i) in reject.reasons"
                            :key="i"
                          >
                            {{ reason.message }}
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </section>
          </div>
        </div>
        <div
          v-if="
            importPreviews.operationDTOS &&
              importPreviews.operationDTOS.length > 0
          "
          class="section ready-section"
        >
          <status-indicator
            statusText="Opérations prêtes"
            statusColor="green"
            sizeType="large"
          />
          <div class="operations-table">
            <span>
              Les opérations suivantes respectent les conditions et seront donc
              importées
            </span>
            <section class="table-section">
              <table class="giga-table">
                <thead>
                  <tr>
                    <th class="sort line-operation-col" scope="col">
                      Num de la ligne
                    </th>
                    <th class="sort name-col" scope="col">
                      Nom de bénéficiaire
                    </th>
                    <th class="sort lastname-col" scope="col">
                      Prénom de bénéficiaire
                    </th>
                    <th class="sort address-col" scope="col">
                      Adresse concaténée
                    </th>
                    <th class="sort fiche-col" scope="col">
                      Fiche CEE
                    </th>
                    <th class="sort dates-col" scope="col">
                      Date d’engagement
                    </th>
                    <th class="sort dates-col" scope="col">
                      Date de la preuve de réalisation
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(estimation, index) in estimationsPreview">
                    <tr :key="index">
                      <td data-label="Numéro de la ligne">
                        <p>{{ estimation.indexLineImport }}</p>
                      </td>
                      <td data-label="Nom de bénéficiaire">
                        <p>
                          {{
                            estimation.beneficiary
                              ? estimation.beneficiary.name
                              : ""
                          }}
                        </p>
                      </td>
                      <td data-label="Prénom de bénéficiaire">
                        <p>
                          {{
                            estimation.beneficiary
                              ? estimation.beneficiary.lastName
                              : ""
                          }}
                        </p>
                      </td>
                      <td data-label="Adresse concaténée">
                        <p
                          v-if="
                            estimation.institution &&
                              estimation.institution.address
                          "
                        >
                          {{ estimation.institution.address | address }}
                        </p>
                        <p v-else></p>
                      </td>
                      <td data-label="Fiche CEE">
                        <p>
                          {{ estimation.fiche ? estimation.fiche.number : "" }}
                        </p>
                      </td>
                      <td data-label="Date d’engagement">
                        <p>
                          {{
                            moment(estimation.beginDate, "x").format(
                              "DD/MM/YYYY"
                            )
                          }}
                        </p>
                      </td>
                      <td data-label="Date de la preuve de réalisation">
                        <p>
                          {{
                            moment(estimation.endDate, "x").format("DD/MM/YYYY")
                          }}
                        </p>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </section>
          </div>
        </div>
      </div>
    </div>
    <confirm-modal
      :id="updateImportInMassModalId"
      :modal_title="$t('confirm-update-import')"
      :content="$t('warning-update-import-in-mass')"
      :loader="false"
      fontSize="h3"
      no-close-on-backdrop
      @yesClick="confirmUpdateImportModal(updateImportInMassModalId)"
      @close="declineUpdateImportModal(updateImportInMassModalId)"
    >
    </confirm-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { map } from "lodash";
import eventBus from "@/shared/event.bus";
import { queryConstant } from "../../../shared/queryConstant";
import { importService } from "@/views/Simulations/services/import.service";
import ListEstimationInMassDoc from "@/views/Simulations/import-mass-estimations/ListEstimationInMassDoc.vue";
import StatusIndicator from "@/components/static/shared/StatusIndicator.vue";
import ConfirmModal from "@/components/static/ConfirmModal.vue";

export default {
  name: "ImportMassStep1",
  components: { ConfirmModal, StatusIndicator, ListEstimationInMassDoc },
  props: [
    "isSimulation",
    "isToBeCompleted",
    "selectDocuments",
    "fileUploadId",
    "replace",
    "isVIEWER",
    "importInMassOperations",
    "filesToFill"
  ],
  data() {
    return {
      updateImportInMassModalId: "confirm-update-import-in-mass",
      uploadSection: true,
      files: [],
      extensions: ["csv"],
      minSize: 1024,
      directory: false,
      drop: true,
      dropDirectory: true,
      createDirectory: false,
      addIndex: false,
      thread: 3,
      name: "file",
      uploadAuto: true,
      isOption: true,
      fieldRequired: true,
      customFilter: queryConstant.setDefaultCustomFilter(),
      importPreviews: null,
      isPreviewInProgress: false
    };
  },

  computed: {
    ...mapGetters("document", [
      "getCurrentStep",
      "getStep1Status",
      "getDraftDocuments",
      "getDocumentsTypes",
      "getDraftDocumentsReplace",
      "getDraftImportInMassDocuments"
    ]),
    ...mapGetters("work", ["getWork"]),
    ...mapGetters("simulation", ["getSimulation", "isEdit", "getOperations"]),
    isInvalid() {
      return this.isTouched && this.value.length === 0;
    },
    getDrafts() {
      return this.getDraftImportInMassDocuments;
    },
    rejects() {
      return !this.importPreviews
        ? null
        : Object.entries(this.importPreviews?.rejections).map(
            ([line, reasons]) => ({
              line,
              reasons
            })
          );
    },
    estimationsPreview() {
      return this.importPreviews?.operationDTOS;
    },
    formIsValid() {
      return !!this.importInMassOperations?.upload?.mappingId;
    }
  },
  mounted() {
    this.getDocumentsTypesAction();
    eventBus.$on("field-required", err => {
      this.fieldRequired = err;
      this.setDocFormInvalid(err);
    });
  },
  methods: {
    ...mapMutations("document", [
      "setCurrentStep",
      "setStep1Status",
      "setDraftDocuments",
      "setDraftDocumentsReplace",
      "setDocFormInvalid",
      "setDraftImportInMassDocuments"
    ]),
    ...mapActions("document", [
      "getDocumentsAction",
      "getDocumentsTypesAction",
      "saveDocumentsAction"
    ]),
    uploadImportInMassDoc(newFile, oldFile) {
      if (newFile && newFile.error !== true) {
        let draftDocuments = [];
        const documentUpload = {};
        documentUpload.workId = newFile.data.workId;
        documentUpload.types = newFile.data.types;
        documentUpload.toBeCompleted = newFile.data.toBeCompleted;
        documentUpload.file = newFile.file;
        documentUpload.fileName = newFile.file.name;
        documentUpload.originalFileName = newFile.file.name;
        draftDocuments.push(documentUpload);
        this.setDraftImportInMassDocuments(draftDocuments);
        this.isPreviewInProgress = true;
      }
      importService
        .getPreviewOperationsInMassAction(
          this.importInMassOperations,
          newFile.file
        )
        .then(importPreviews => {
          newFile.success = true;
          newFile.progress = 100;
          this.importPreviews = importPreviews;
          if (this.importPreviews && this.getOperations?.content) {
            this.openConfirmModal("confirm-update-import-in-mass");
          }
        })
        .catch(error => {
          newFile.success = false;
          newFile.progress = 100;
          this.importPreviews = null;
        })
        .finally(() => {
          this.isPreviewInProgress = false;
        });
    },
    isToBeCompletedContext(filesLength) {
      if (this.isToBeCompleted) {
        eventBus.$emit("deleteSelectedDocument");
      } else {
        eventBus.$emit("reloadDocuments", filesLength);
      }
    },
    getFileExtention(filename) {
      return filename.split(".").pop();
    },
    replaceDocument: function() {
      const drafts = this.getDraftDocumentsReplace;
      if (drafts && drafts.length > 0) {
        drafts.forEach(document => {
          if (Array.isArray(document.types)) {
            document.types = map(document.types, "code");
          } else {
            document.types = [document.types.code];
          }
        });
        this.setDraftDocumentsReplace(null);
        this.saveDocumentsAction({
          id: parseInt(this.$route.params["id"], 10),
          customFilter: this.customFilter,
          documentsToUpload: drafts
        });
      }
      eventBus.$emit("unselectDocs");
      eventBus.$emit("deleteSelectedDocument");
    },
    initFiles() {
      if (
        this.getDraftImportInMassDocuments &&
        this.getDraftImportInMassDocuments.length === 0
      ) {
        this.initializeImportInMass();
      }
    },
    initializeImportInMass() {
      this.files = [];
      this.importPreviews = null;
    },
    confirmUpdateImportModal(modal) {
      this.$root.$emit("bv::hide::modal", modal);
    },
    declineUpdateImportModal(modal) {
      this.initializeImportInMass();
      this.$root.$emit("bv::hide::modal", modal);
    },
    openConfirmModal(modal) {
      this.$root.$emit("bv::show::modal", modal);
    }
  },
  watch: {
    estimationsPreview(newValue) {
      this.$emit("estimations-preview-updated", newValue);
    },
    filesToFill(newVal) {
      if (this.filesToFill) {
        this.files = this.filesToFill;
      }
    }
  },
  beforeDestroy() {
    eventBus.$off("field-required");
  }
};
</script>

<style lang="scss">
.import-previews-div {
  margin-top: 30px;
}
.alert {
  background-color: #e1edf6;
  border: solid 1px #6890f9;
  border-left-width: 5px;
  font-size: 14px;
  font-weight: 500;
  color: #143a5a;
  display: flex;
  padding: 6px 21px;
  .material-symbols-outlined {
    margin-right: 10px;
    color: #6890f9;
  }
}
.section {
  box-shadow: 0 0 25px 0 rgba(52, 74, 87, 0.05);
  border: solid 1px #e0e7ee;
  margin: 10px 0;
  padding: 10px 35px 25px 17px;

  .title {
    display: flex;
    font-size: 14px;
    font-weight: 500;
    align-items: center;
    color: #143a5a;

    .dot {
      width: 10px;
      height: 10px;
      border-radius: 10px;
      margin-right: 6px;
      &.red {
        background-color: #ff4f4f;
      }
      &.green {
        background-color: #6cbe3e;
      }
    }
  }
}
.operations-table {
  margin-left: 18px;
  span:first-child {
    font-size: 13px;
    color: #000000;
  }
  section {
    margin-top: 15px;
  }
}

.table-section {
  max-height: 300px;
  overflow: auto;
}

.disc {
  list-style: disc;
}

.line-col {
  width: 30% !important;
}
.motif-col {
  width: 70% !important;
}
.line-operation-col {
  width: 8% !important;
}
.name-col {
  width: 19% !important;
}
.lastname-col {
  width: 20% !important;
}
.fiche-col {
  width: 46% !important;
}
.address-col {
  width: 27% !important;
}
.dates-col {
  width: 18% !important;
}
</style>
